import React, { useEffect, useRef } from 'react';
import classNames from 'classnames';
import Heading from '../../Atoms/Heading/Heading';
import Image from '../../Atoms/Image/Image';
import { OUT_OF_STOCK, REMOVE_FAVORITE } from '../../../constants/App';
import Fav from '../../../assets/RemoteOrder/img/fav.svg';
import Plus from '../../../assets/RemoteOrder/img/plus.svg';
import Checkmark from '../../../assets/RemoteOrder/icons/filled-checkmark.svg';
import Button from '../../Atoms/Button/Button';
import _isEmpty from 'lodash/isEmpty';
import _get from 'lodash/get';
import _gt from 'lodash/gt';
import InnerHTML from '../../Atoms/SetInnerHTML/InnerHTML';
import { containsHTMLTags, currencyPlacement } from '../../../Utils/pageUtils';
import { componentRenderCheck, multipleAndCheck, ternaryCheck } from '../../../Utils/WindowUtils';
import Lottie from 'lottie-react';
import DancingDotsGreen from '../../../../src/assets/RemoteOrder/confettie/DancingDotsGreen.json';
import FeedIcon from '../../../assets/RemoteOrder/img/groups.svg';
export interface CardMenuProps {
  imageURL: [] | string;
  title: string | React.JSX.Element;
  description?: string | React.JSX.Element;
  isFavourite?: boolean;
  isPayment?: boolean;
  inStock?: boolean;
  isCatering?: boolean;
  price?: number;
  badgeTitle?: string;
  badgeColor?: any;
  rewardType?: string;
  enableButton?: boolean;
  buttonHandler?: (value: React.SyntheticEvent<EventTarget>) => void;
  buttonText?: string;
  showBorder?: boolean;
  tosHandler?: {
    tosLabel: string;
    tosHandlerFn: React.Dispatch<React.SetStateAction<boolean>>;
  } | null;
  rewardText?: string;
  productName?: string;
  linkText?: string;
  linkURL?: string;
  heartIconClickHandler?: any;
  children?: React.ReactNode;
  isDisabled?: boolean;
  cardButtonClassName?: string;
  testAutoIds?: {
    badgeTitleTestAutoId?: string;
    cardTitleTestAutoId?: string;
    cardDescriptionTestAutoId?: string;
    cardImageTestAutoId?: string;
  };
  showPlusIcon?: boolean;
  plusIconHandler?: any;
  showTickMark?: boolean;
  bundlePrice?: { maxPrice: number; minPrice: number };
  cardTextData?: { key: string, value: string }[];
  imageSize?: string;
  isLottieLoading?: boolean;
  isPlusIconLottieCircle?: boolean;
  comboBrightPrice?: number;
  calories?: number;
  todayDeal?: boolean;
  bagPageCardMenu?: boolean;
  cardDetailsCatering?: { feedsText?: string, feedsQuantity?: any, isFromShow?: boolean };
  recommendedBadge?: {
    text?: string;
    textColor?: string;
    backgroundgcolor?: string;
  };
}

const CardMenu: React.FC<CardMenuProps> = ({
  imageURL,
  title,
  description,
  isFavourite,
  isPayment,
  inStock,
  isCatering,
  price,
  badgeTitle,
  badgeColor = null,
  rewardType = '',
  enableButton = false,
  buttonText = '',
  tosHandler,
  rewardText,
  productName,
  heartIconClickHandler,
  children,
  buttonHandler,
  isDisabled = false,
  cardButtonClassName = '',
  showBorder,
  testAutoIds = {},
  showPlusIcon = false,
  plusIconHandler,
  showTickMark,
  bundlePrice,
  cardTextData,
  isPlusIconLottieCircle,
  imageSize = '',
  isLottieLoading,
  comboBrightPrice,
  calories,
  todayDeal,
  bagPageCardMenu = false,
  cardDetailsCatering = {},
  recommendedBadge,
}) => {
  const { feedsText, feedsQuantity, isFromShow } = cardDetailsCatering;
  const isFeed = _gt(parseInt(feedsQuantity), 0);
  const cardRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const badgeElement = cardRef?.current?.querySelector(".card__is-new") as HTMLHeadingElement;
    const plusIconElement = cardRef?.current?.querySelector(".plus__icon_badge") as HTMLButtonElement;
    if (plusIconElement) {
      plusIconElement.style.top = `calc(${badgeElement?.offsetHeight}px + 1rem)`
    }
  }, [cardRef]);

  const cardImg = classNames('card__img', {
    'card__img--fav': isFavourite,
    'card__img--with-recommended-badge': !_isEmpty(recommendedBadge?.text),
  });
  const cardmenu = classNames('card__menu', {
    'cart__items--red-border': multipleAndCheck(!_isEmpty(showBorder), !showBorder),
    'cart__items--green-border': showBorder,
  });
  const isPlusIconBadgeActive = multipleAndCheck(badgeTitle, inStock);
  const lottiecircle = classNames('lottie-placement', {
    'lottie-circle': isPlusIconLottieCircle,
    'lottie-circle-badge': isPlusIconBadgeActive,
    'lottie-circle--with-recommended-badge': !_isEmpty(recommendedBadge?.text),
  });
  const rewardTextType = classNames('card__reward-type', {
    'card__reward-type--free-reward': rewardType == 'freeReward',
    'card__reward-type---mvd-reward': rewardType == 'mvdReward',
  });
  const cardPrimaryButton = classNames('primary__btn', {
    'secondary__btn rewardspage__card': cardButtonClassName == 'rewardsPage',
    card__button: cardButtonClassName != 'rewardsPage',
  });
  const isContainsHTMLTags = containsHTMLTags(description);
  const cardTextHandler = (val: string) => {
    const text = cardTextData?.filter((item) => { if (item.key == val) { return item.value } })
    return text?.[0]?.value
  }
  const featuredComboPricingType = (window as any).client.variation(
    (window as any).FF_COMBOS_BEFORE_AND_AFTER_PRICING,
    'SINGLE_PRICE',
  );
  const handlePricingText = (minPrice?: number, maxPrice?: number) => {
    if (featuredComboPricingType) {
      if (featuredComboPricingType == 'SINGLE_PRICE') {
        return `${cardTextHandler('from')}: ${currencyPlacement('$', minPrice)}`
      }
      if (featuredComboPricingType == 'NO_PRICE') {
        return ''
      }
      if (featuredComboPricingType == 'BEFORE_AND_AFTER_PRICE') {
        return <>{cardTextHandler('from')}: {currencyPlacement('$', minPrice)} {maxPrice && <span className='card__bottom__oldPrice'> {currencyPlacement('$', maxPrice)}</span>}</>
      }
    }
  }
  const handleTitle = () => {
    return (
      <>
        {handlePricingText(bundlePrice?.minPrice, bundlePrice?.maxPrice)}&nbsp;
        {!_isEmpty(handlePricingText(bundlePrice?.minPrice, bundlePrice?.maxPrice)) && (
          <span>&bull;</span>
        )}
        &nbsp;{calories}&nbsp;{ternaryCheck(!!calories, cardTextHandler('cals'), '')}
      </>
    )
  }

  const getBadgedColor = () => {
    return badgeColor?.isPrimary ? '#000000' : '#FFFFFF';
  }
  const getFeedData = (showFeed: boolean) => {
    return componentRenderCheck(showFeed, (<p className="feed_details">
      <FeedIcon /> {feedsText} {feedsQuantity}
    </p>))
  }
  const {
    badgeTitleTestAutoId,
    cardTitleTestAutoId,
    cardDescriptionTestAutoId,
    cardImageTestAutoId,
  } = testAutoIds;
  const getCateringTitle = () => {
    const fromText = `${cardTextHandler('from')} :`
    const currencyFormat = currencyPlacement('$', price)
    const cardText = cardTextHandler('perperson')
    return `${isFromShow ? fromText : ''} ${currencyFormat} ${cardText}`
  };
  return (
    <div className={cardmenu} ref={cardRef}>
      {componentRenderCheck(multipleAndCheck(inStock != null, !inStock), <Heading level="p" data-testid={OUT_OF_STOCK} className="card__out-of-stock" title={cardTextHandler('outOfStock') || OUT_OF_STOCK} />)}
      {isFavourite && (
        <Button
          testAutoId="favorite__icon"
          className="favorite__icon"
          data-testid={`favorite-heart-icon-${title}`}
          onClick={e => heartIconClickHandler(e)}
          aria-label={`${REMOVE_FAVORITE}: ${productName}`}
        >
          <Fav />
        </Button>
      )}

      {isLottieLoading && (
        <div className={lottiecircle}>
          <Lottie className={`in-context-card-loader`} animationData={DancingDotsGreen} />
        </div>
      )}

      {componentRenderCheck(showPlusIcon, (
        <Button
          testAutoId="plus__icon"
          className={classNames('plus__icon', {
            'plus__icon_badge': isPlusIconBadgeActive,
            'plus__icon--with-recommended-badge': !_isEmpty(recommendedBadge?.text),
          })}
          data-testid={`plus-icon-${title}`}
          onClick={plusIconHandler}
          aria-label={`${cardTextHandler('addToBag')}: ${title}`}
        >
          {showTickMark ? <Checkmark /> : <Plus />}
        </Button>
      ))}

      {multipleAndCheck(badgeTitle, (inStock !== false)) && (
        <Heading
          {...(!_isEmpty(badgeColor) && { style: { backgroundColor: badgeColor?.color, color: getBadgedColor() } })}
          className="card__is-new"
          testAutoId={badgeTitleTestAutoId}
          level="span"
          title={badgeTitle}
        />
      )}
      <div className="card__subcontainer">
        <div className={cardImg}>
          <Image
            className="card__image"
            imageSources={imageURL}
            alt={isFavourite || isPayment ? productName : ''}
            testAutoId={cardImageTestAutoId}
            imageSize={imageSize}
          />
        </div>
        <div className="card__details">
          {rewardText && <span className={rewardTextType}>{rewardText}</span>}
          {componentRenderCheck(!_isEmpty(recommendedBadge?.text),
            <Heading
              style={{
                backgroundColor: recommendedBadge?.backgroundgcolor,
                color: recommendedBadge?.textColor,
              }}
              className="recommended__badge"
              testAutoId={"recommended-badge"}
              level="h4"
              title={recommendedBadge?.text}
            />)}
          {ternaryCheck(bagPageCardMenu, <Heading
            level='h2'
            className="card__title"
            testAutoId={cardTitleTestAutoId}
            title={title}
          />,
            <div className="card_heading">
              <InnerHTML
                Tag="h2"
                className="card__title"
                testAutoId={cardTitleTestAutoId}
                text={title}
              />
              <>{getFeedData(multipleAndCheck(isFeed, !isCatering))}</>
            </div>
          )}
          {ternaryCheck(isContainsHTMLTags
            , description && (
              <InnerHTML
                Tag="p"
                testAutoId={cardDescriptionTestAutoId}
                className="card__description"
                text={description}
              />
            )
            , description && (
              <Heading
                level="p"
                className="card__description"
                testAutoId={cardDescriptionTestAutoId}
                title={description}
              />
            ))}
        </div>
        {isCatering && (
          <div className="categring__card__bottom">
            <Heading
              testAutoId={'categring__card__bottom_price'}
              title={getCateringTitle()}
              className="categring__card__bottom_price"
              level="p"
            />
            <>{getFeedData(isFeed)}</>
          </div>
        )}
        {comboBrightPrice && (
          <div className="bright__card__bottom">
            <Heading
              testAutoId={'bright__card__bottom__price'}
              title={handlePricingText(comboBrightPrice)}
              className="bright__card__bottom__price"
              level="p"
            />
          </div>
        )}
        {bundlePrice?.maxPrice && (
          <div className="card__bottom">
            <Heading
              testAutoId={'card__bottom__price'}
              title={handleTitle()}
              className="card__bottom__price"
              level="p"
            />
          </div>
        )}
        {componentRenderCheck(multipleAndCheck(_get(bundlePrice, 'minPrice', 0) > 0, todayDeal, featuredComboPricingType != 'NO_PRICE'), (
          <div className="card__bottom">
            <Heading
              testAutoId={'card__bottom__price'}
              title={`${cardTextHandler('from')} ${currencyPlacement('$', bundlePrice?.minPrice)}`}
              className="card__bottom__price"
              level="p"
            />
          </div>
        ))}
      </div>
      {componentRenderCheck(enableButton, (
        <div className="card__action">
          <Button
            isDisabled={isDisabled}
            testAutoId={`card-cta-${title}`}
            aria-label={`${title} ${buttonText}`}
            className={cardPrimaryButton}
            onClick={buttonHandler}
          >
            {buttonText}
          </Button>
          {tosHandler && (
            <Button
              className="card__tos"
              testAutoId="card-tos"
              onClick={() => tosHandler?.tosHandlerFn(true)}
            >
              {tosHandler?.tosLabel}
            </Button>
          )}
        </div>
      ))}
      {children}
    </div>
  );
};

export default CardMenu;
